import isEmpty from '../../utility/isEmpty'
import logger from '../../utility/loggerUtil'
import { DisbursementTypeEnum, KeyConstants, PaymentTypeEnum } from '../../constants.js'

export default {
  isRefiFlowEligible (state, getters) {
    const isDisburseOrProdSwitchWithAmount = ((state.loan.validations && state.loan.validations.isDisbursementAvailable) || !isEmpty(state.loan.disburseProductMigration)) && // Check normal addon disbursement and switch addon disbursement availability
      state.disbursementAmount > 0
    const paymentIsNotPayoff = state.paymentAmount !== state.loan.payoffAmount
    const maxRefiPaymentAmount = state.loan.payoffAmount - state.loan.minimumLoanAmount
    const paymentBelowPayoffAndMinLoanAmount = state.paymentAmount <= +(maxRefiPaymentAmount.toFixed(2))

    logger.debug(`Loan ${state.loan.loanId} - Can guest refi: ${getters.canGuestRefi}`)
    logger.debug(`Loan ${state.loan.loanId} - Is not prevent refi: ${state.preventRefi === false}`)
    logger.debug(`Loan ${state.loan.loanId} - Is Refi eligible or disburse eligible: ${state.loan.refinanceEligible || isDisburseOrProdSwitchWithAmount}`)
    logger.debug(`Loan ${state.loan.loanId} - Is payment amount not equal to payoff: ${paymentIsNotPayoff}`)

    if (state.loan.lmsId !== KeyConstants.lmsIds.NLS) {
      logger.debug(`Loan ${state.loan.loanId} - Payment is above min/product switch amount due: ${getters.hasLowerMinAmount}`)
      logger.debug(`Loan ${state.loan.loanId} - Payment is equal to or below payoff minus minimum loan amount of ${maxRefiPaymentAmount}: ${paymentBelowPayoffAndMinLoanAmount}`)
    }

    return getters.canGuestRefi &&
      state.preventRefi === false &&
      (state.loan.refinanceEligible || isDisburseOrProdSwitchWithAmount) &&
      paymentIsNotPayoff &&
      (state.loan.lmsId === KeyConstants.lmsIds.NLS || (getters.hasLowerMinAmount && paymentBelowPayoffAndMinLoanAmount))
  },

  canGuestRefi (state) {
    return state.guestPayment === false || (state.loan.validations && state.loan.validations.guestFeatures && state.loan.validations.guestFeatures.guestRefinanceEnabled)
  },

  hasLowerMinAmount (state) {
    const minAmount = isEmpty(state.loan.productSwitchAmountDue) || state.paymentAmountType !== 'onlineProduct' ? state.loan.minimumAmountDue : Math.min(state.loan.minimumAmountDue, state.loan.productSwitchAmountDue)
    const hasLowerMinAmount = state.paymentAmount >= minAmount

    logger.debug(`Loan ${state.loan.loanId} - Payment equal to or above minimum amount due of ${minAmount}: ${hasLowerMinAmount}`)

    return hasLowerMinAmount
  },

  hasAlternate (state) {
    return !isEmpty(state.loan) && state.loan.cosignerId && state.loan.cosignerId > 0
  },

  isAlternate (state, getters, rootState) {
    return state.loan.cosignerId && state.loan.cosignerId > 0 && state.loan.cosignerId.toString() === rootState.customer.customerId.toString()
  },

  altPartyCustomerId (state, getters) {
    return getters.isAlternate ? state.loan.customerId : state.loan.cosignerId
  },

  altPartyName (state) {
    return state.loan.alternateName
  },

  isPartialPayment (state, getters) {
    return state.loan.daysLate > 0 && state.paymentAmount !== 0 && (state.loan.validations && state.loan.validations.partialPayConfirmViewable) && state.paymentAmount < state.loan.minimumRequiredAmount && (state.paymentAmountType === 'other' || getters.isOfrReinstate)
  },

  isOfrReinstate (state) {
    if (isEmpty(state.loan.validations)) {
      return false
    }

    return state.loan.validations.isOfrReinstateAmount && state.loan.validations.isInOfrStatus
  },

  isStoreDisbursement (state) {
    return state.disbursementType === DisbursementTypeEnum.store
  },

  isMoneyGramDisbursement (state) {
    return state.disbursementType === DisbursementTypeEnum.moneyGram
  },

  isDebitDisbursement (state) {
    return state.disbursementType === DisbursementTypeEnum.debit
  },

  isAchDisbursement (state) {
    return state.disbursementType === DisbursementTypeEnum.ach
  },

  disburseCard (state, getters, rootState) {
    if (isEmpty(state.disburseCardId) || isEmpty(state.disburseCardNumber)) {
      return undefined
    }

    return {
      cardId: state.disburseCardId,
      cardHolderName: state.disburseCardHolderName,
      cardNumber: state.disburseCardNumber,
      cardType: state.disburseCardType
    }
  },

  hasSetDisburseCard (state) {
    return !isEmpty(state.disburseCardId)
  },

  isSettlementPayment (state) {
    return state.paymentType === PaymentTypeEnum.settlement
  },

  isDisbursement (state) {
    return !isEmpty(state.disbursementAmount) ? state.disbursementAmount > 0 : false
  },

  bridgePayDisbursementEnabled (state) {
    return !isEmpty(state.loan.bridgePayDisburseProvider) ? state.loan.bridgePayDisburseProvider : false
  },

  getValidations (state) {
    return (isDisbursement) => {
      if (isDisbursement && state.migrateProduct) {
        return isEmpty(state.loan.disburseProductMigration) && isEmpty(state.loan.disburseProductMigration.validations) ? {} : state.loan.disburseProductMigration.validations
      }
      return isEmpty(state.loan.validations) ? {} : state.loan.validations
    }
  }
}
